import {
  REGISTER_FOR_NOTIFICATIONS_FAILURE,
  REGISTER_FOR_NOTIFICATIONS_SUCCESS,
  REGISTER_FOR_NOTIFICATIONS_START,
} from '../store/types';

const initialState = {
  PushToken: null,
  error: {
    message: null,
    flagged: false,
  },
};

// eslint-disable-next-line no-undef
export const pushtokenreducer = (state = initialState, {type, payload}) => {

  switch (type) {
    case REGISTER_FOR_NOTIFICATIONS_START:
      return {...state};

    case REGISTER_FOR_NOTIFICATIONS_SUCCESS:
      return {...state, PushToken: payload};

    case REGISTER_FOR_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        error: {
          flagged: true,
          message: payload,
        },
      };

    default:
      return state;
  }
};
